// URL Parameters and Tracking Codes
export const BRAND_BASE_URL = "https://drivenentrepreneur.com";
export const CDN_BASE_URL = "https://cdn.drivenentrepreneur.com";
export const CART_BASE_URL = "https://cart.drivenentrepreneur.com";
export const BRIGHTCOVE_BASE_URL = "https://players.brightcove.net/6058004206001";
export const ONE_SHOPPING_CART_URL = "https://www.1shoppingcart.com";
export const LEGAL_BASE_URL = "https://legal.drivenentrepreneur.com";

// External Service URLs
export const EXTERNAL_URLS = {
  THEHEALTHYFAT: "https://www2.thehealthyfat.com",
  PAYPAL_BUTTON: "https://www2.thehealthyfat.com/assets/img/paypalButton.jpg"
};

// Podcast URLs
//UPDATE BELOW LINKS WHEN AVAILABLE AND DELETE THIS COMMENT
export const PODCAST_URLS = {
  ITUNES: "https://itunes.apple.com/us/podcast/the-dr-gundry-podcast/id1434371530",
  YOUTUBE: "https://www.youtube.com/playlist?list=PLdIdMvoKskiSDn3ZxzRkqtxtY_oGKqbRl",
  STITCHER: "https://www.stitcher.com/podcast/the-dr-gundry-podcast",
  OVERCAST: "https://overcast.fm/itunes1434371530/the-dr-gundry-podcast",
  CASTBOX: "https://castbox.fm/search?q=Dr%20Gundry%20Podcast&country=us&skip=0&limit=50&order=relevance&research=1"
};

// CDN Image URLs
export const CDN_IMAGES = {
  BRAND_LOGO: `${CDN_BASE_URL}/images/drivenEntrepreneur-logo.png`,
  BRAND_LOGO_TRANSPARENT: `${CDN_BASE_URL}/images/drivenEntrepreneur-logo_transparent.png`,
  LOGO_SHORT: `${CDN_BASE_URL}/images/drivenentrepreneur-Logo_short.png`,
  PALM_WAIT: `${CDN_BASE_URL}/images/palm_wait.svg`,
  UP_YES: `${CDN_BASE_URL}/images/upYes.jpg`,
  UP_NO: `${CDN_BASE_URL}/images/upNo.jpg`,
  UP_YES_MOBILE: `${CDN_BASE_URL}/images/upYes_mobile.jpg`,
  UP_NO_MOBILE: `${CDN_BASE_URL}/images/upNo_mobile.jpg`,
  GRAY_CHECK: `${CDN_BASE_URL}/images/gray_check2.png`,
  BLUE_CHECK: `${CDN_BASE_URL}/images/blue_check.png`,
  HEALTH_IMAGE: `${CDN_BASE_URL}/images/5c1e24a802aa7adbf71d89a06ddb417581fa46ea.jpg`,
  FIELD_DESKTOP: `${CDN_BASE_URL}/images/Field_Desktop.png`,
  GUNDRY_BOTTOM_CORNER: `${CDN_BASE_URL}/images/gundry-bottom-corner.png`,
  SPINNING_WHEEL_CIRCLES: `${CDN_BASE_URL}/images/spinning-wheel-small_circlesfull.png`,
  SPINNING_WHEEL_TRIANGLE: `${CDN_BASE_URL}/images/spinning-wheel-triangle.png`,
  MONEYBACK_GUNDRY: `${CDN_BASE_URL}/images/moneyback-gundry.png`,
  PHONE: `${CDN_BASE_URL}/images/phone.png`,
  GUNDRY_BODY: `${CDN_BASE_URL}/images/gundry-body.png`,
  RED_CHECK: `${CDN_BASE_URL}/images/red-check.png`,
  ORANGE_CHECK: `${CDN_BASE_URL}/images/orangeCheck.webp`,
  LOGO_CIRCLE: `${CDN_BASE_URL}/images/logo-circle.png`,
  BIOC_COMPLETE3_SUPP: `${CDN_BASE_URL}/images/bio-complete-3/BioComplete3-supp.png`,
  STAR_GREEN: `${CDN_BASE_URL}/1starGreen.png`,
  MYACCOUNT_CHECKMARK: `${CDN_BASE_URL}/images/Myaccount-checkmark-sign-up.png`,
  GUNDRY_SCRUBS_GREEN: `${CDN_BASE_URL}/images/gundry_scrubs_green.png`,
  BRAND_LOGO_3X: `${CDN_BASE_URL}/images/drivenentrepreneur-Logo@3x.png`,
  GUNDRY_SCRUBS: `${CDN_BASE_URL}/images/Gundry_Scrubs.png`,
  PHONE2: `${CDN_BASE_URL}/images/phone2.png`,
  CHECKOUT_90DAY: `${CDN_BASE_URL}/images/checkout_90day.png`,
  TROPHY: `${CDN_BASE_URL}/images/trophy.svg`,
  CHECKOUT_TRUCK: `${CDN_BASE_URL}/images/checkout_truck.svg`,
  SUBSCRIPTION_TERMS: `${CDN_BASE_URL}/Terms_Conditions/gundry-subscription-terms.html`,
  FB_LOGO: `${CDN_BASE_URL}/images/facebook-icon.svg`,
  INSTAGRAM_LOGO: `${CDN_BASE_URL}/images/instagram-icon.svg`,
  TIKTOK_LOGO: `${CDN_BASE_URL}/images/tiktok-icon.svg`,
  X_LOGO: `${CDN_BASE_URL}/images/X-icon.svg`,
  SALE_TAG: `${CDN_BASE_URL}/images/saleTag.svg`,
  LOCK_ICON: `${CDN_BASE_URL}/images/lock-3x.png`,
  CTAARROW_ICON: `${CDN_BASE_URL}/images/CTA_Arrow--large.svg`,
};

export const LINK_PAGES = {
  CA_PRIVACY_NOTICE: `${LEGAL_BASE_URL}/privacy-policy#Additional-Information-for-California-Residents`,
  PRIVACY_POLICY: `${LEGAL_BASE_URL}/privacy-policy`,
  REGISTER: `${CART_BASE_URL}/register/`,
  TERMS_AND_CONDITIONS: `${LEGAL_BASE_URL}/terms`,
  YOUR_PRIVACY_CHOICES: `${BRAND_BASE_URL}/your-privacy-choices`,
};

export const CUSTOMER_SERVICE_PHONE = '+1 (888) 782-8804';
export const CUSTOMER_SERVICE_HOURS_MOBILE = 'M–F 6am-5pm | S–S 6am-4pm PST';
export const CUSTOMER_SERVICE_HOURS_DESKTOP = 'Mon–Fri 6am–5pm PST | Sat-Sun 6am-4pm PST';
export const CUSTOMER_SERVICE_EMAIL = 'support@drivenentrepreneur.com';
export const ADDRESS = '23371 Mulholland Dr., STE 491, Woodland Hills, CA 91364';
export const FOOTER_DISCLAIMER = 'GHRH SA, LLC d/b/a Driven Entrepreneur ("Driven Entrepreneur") makes no guarantees or representations regarding results, income, or earnings from the use of our website, products, services, programs, or any third-party resources referenced. All information provided is for educational and informational purposes only and should not be interpreted as a promise of financial success or specific outcomes. Any examples, forward-looking statements, or references to potential results or earnings reflect opinions or possibilities only and do not represent typical or average results. Individual outcomes vary widely based on numerous factors, including experience, effort, skills, market conditions, and personal circumstances, many of which are beyond our control. Past results do not guarantee future performance. By using our website or services, you agree that you assume full responsibility for your decisions and results, and that Driven Entrepreneur, LLC and its affiliates are not liable for any outcomes resulting from your use of our information.';

export const PARAM = "n";
export const OBTCR = "obtcr";
export const TBATCR = "tbatcr";
export const FBTCR = "fbtcr";
export const DBTCR = "dbtcr";
export const REVTCR = "revtcr";
export const ADV = "Advertorial";
export const ADVERT = "Advertisement";
export const OPT = 'opt';
export const OBNATCR = 'obnatcr';
export const MSNTCR = 'msntcr';
export const OB = 'ob';
export const AOL = 'aol';
export const AOLTCR = 'aoltcr';
export const GDN = 'gdn';
export const GDNTCR = 'gdntcr';
export const AYAHTCR = 'ayahtcr';
export const AYAHC = 'ayahc';
export const AYAHLG = 'ayahlg';
export const ATBATCR = 'atbatcr';
export const VMXGUN = 'vmxgun';
export const RMGEM = 'rm-gem';
